import { ulidRegex } from '../constants';

const ourValidId = (id: string) => ulidRegex.test(id);

export default ourValidId;
